module.exports = __webpack_public_path__ + "img/Asset cowok cewek (full badan).bac13d47.svg";